import React, { useMemo } from "react";
import SimpleDropdown, {
  SimpleDropdownLabel,
} from "../forms/general/SimpleDropdown";

interface ProjectTypeFilterProps {
  projects: any[];
  selectedType: string;
  onTypeChange: (type: string) => void;
  theme?: string;
}

const ProjectTypeFilter: React.FC<ProjectTypeFilterProps> = ({
  projects,
  selectedType,
  onTypeChange,
  theme,
}) => {
  const types = useMemo(
    () => [
      "All",
      ...Array.from(new Set(projects.map((project) => project.type))),
    ],
    [projects]
  );

  return (
    <div className={`relative w-48`}>
      <SimpleDropdown
        options={types.map((type) => ({
          id: type as string,
          name: type as string,
        }))}
        label={SimpleDropdownLabel.Type}
        onChange={(selected) => onTypeChange(selected)}
        value={selectedType}
        theme={theme}
      />
    </div>
  );
};

export default ProjectTypeFilter;
